import { makeEnvironmentProviders, Provider } from "@angular/core";
import { SvgHttpLoader, SvgLoader } from "./svg-loader";
import { SERVER_URL, VDS_ICON_REGISTRY_PROVIDER } from "./vds-icon-registry.service";

export interface VdsIconConfig {
    loader?: Provider;
    url?: string;
}

export function provideIcons(config: VdsIconConfig = {}) {
    return makeEnvironmentProviders([
        { provide: SERVER_URL, useValue: config?.url ?? "assets/icons" },
        VDS_ICON_REGISTRY_PROVIDER,
        config.loader || { provide: SvgLoader, useClass: SvgHttpLoader }
    ]);
}
